import { render, staticRenderFns } from "./SeizureLandInventoryShow.vue?vue&type=template&id=605d89e8&scoped=true"
import script from "./SeizureLandInventoryShow.vue?vue&type=script&lang=js"
export * from "./SeizureLandInventoryShow.vue?vue&type=script&lang=js"
import style0 from "./SeizureLandInventoryShow.vue?vue&type=style&index=0&id=605d89e8&prod&scoped=true&lang=css"
import style1 from "./SeizureLandInventoryShow.vue?vue&type=style&index=1&id=605d89e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "605d89e8",
  null
  
)

export default component.exports